/**
 * ReportsHarvestInspectionsTableHead
 */
import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
import TableHeadTableCell from '../../../../../../components/TableHeadTableCell';
import HarvestEventTypeSchemaEntityTypeName from '../../../../../../components/HarvestEventTypeSchemaEntityTypeName';
import HarvestEventTypeSchemaParentEntityTypeName from '../../../../../../components/HarvestEventTypeSchemaParentEntityTypeName';

interface Props {
    jobType?: string;
    defaultSort: string;
}

export default class ReportsHarvestInspectionsTableHead extends React.PureComponent<Props> {
    render() {
        const { jobType, defaultSort } = this.props;
        return (
            <Table.Header
                // HACK inline styles
                style={{
                    fontSize: 14
                }}
            >
                <Table.Row>
                    <TableHeadTableCell
                        label={<HarvestEventTypeSchemaParentEntityTypeName />}
                        value="parentEntityName"
                        defaultSort={defaultSort}
                    />
                    <TableHeadTableCell
                        label={<HarvestEventTypeSchemaEntityTypeName />}
                        value="entityName"
                        defaultSort={defaultSort}
                    />
                    <TableHeadTableCell
                        label="Variety"
                        value="varietyName"
                        defaultSort={defaultSort}
                    />
                    <TableHeadTableCell
                        label="Pick"
                        value="pickTypeName"
                        defaultSort={defaultSort}
                    />
                    {jobType === 'INSPECTION' && (
                        <React.Fragment>
                            <TableHeadTableCell
                                label="# Inspections"
                                value="numberOfInspections"
                                defaultSort={defaultSort}
                            />
                            <TableHeadTableCell
                                label="Avg. Count Size"
                                value="averageSize"
                                defaultSort={defaultSort}
                            />
                            <TableHeadTableCell
                                label="Cosmetic"
                                value="cosmeticDefectPercentage"
                                defaultSort={defaultSort}
                            />
                            <TableHeadTableCell
                                label="Pest"
                                value="pestDefectPercentage"
                                defaultSort={defaultSort}
                            />
                            <TableHeadTableCell
                                label="Picker Faults"
                                value="pickerFaultPercentage"
                                defaultSort={defaultSort}
                            />
                            <TableHeadTableCell
                                label="Spoilt"
                                value="spoiltDefectPercentage"
                                defaultSort={defaultSort}
                            />
                            <TableHeadTableCell
                                label="Overall Defects"
                                value="overallDefectPercentage"
                                defaultSort={defaultSort}
                            />
                        </React.Fragment>
                    )}
                    {jobType === 'TIMESHEET' && (
                        <React.Fragment>
                            <TableHeadTableCell
                                label="# Bins"
                                value="numberOfContainers"
                                defaultSort={defaultSort}
                            />
                        </React.Fragment>
                    )}
                    <Table.HeaderCell
                        className="events-table-cell-padding"
                        style={{ cursor: 'auto' }}
                    />
                </Table.Row>
            </Table.Header>
        );
    }
}
